// src/components/features/Elevation/components/shared/SmartImage.jsx
// Landscape aur portrait — dono tarah ki images ko cleanly dikhata hai.
// Peeche wahi image blurred+cover ho ke poora background fill karti hai,
// aur upar wahi image "contain" mode me — poori dikhti hai, kabhi crop
// nahi hoti. (ElevationStep1Theme.jsx me pehle se isi pattern ka use ho
// raha hai — ye us logic ko saare Elevation steps ke liye reusable banata hai.)

import { Box, Flex } from "@chakra-ui/react";

export default function SmartImage({ src, alt = "" }) {
  if (!src) return null;
  return (
    <Box position="absolute" inset={0} overflow="hidden">
      {/* Blurred backdrop — gaps ko fill karta hai */}
      <Box
        position="absolute" inset={0}
        bgImage={`url(${src})`} bgSize="cover" bgPos="center"
        filter="blur(16px) brightness(0.7)"
        transform="scale(1.15)"
      />
      {/* Actual image — poori nazar aati hai, kabhi crop nahi hoti */}
      <Flex position="absolute" inset={0} align="center" justify="center">
        <Box
          as="img"
          src={src}
          alt={alt}
          maxW="100%"
          maxH="100%"
          w="auto"
          h="auto"
          objectFit="contain"
          draggable={false}
        />
      </Flex>
    </Box>
  );
}
